module.exports = __webpack_public_path__ + "static/media/notfound.8c3d2a79.svg";